module.exports = __webpack_public_path__ + "static/media/8.9aac4546.jpg";